// Conteudo do arquivo IMPORT_FAQ_JSON.md oferecido para download na modal de importacao.
// O administrador baixa e entrega ao agente de IA para gerar um JSON valido.
// Montado por array de linhas (single-quoted) para suportar as crases do markdown sem escapes.

const lines = [
  '# Instrucoes para gerar o JSON de FAQ da campanha (AUCR-791)',
  '',
  'Voce vai gerar um JSON com as perguntas e respostas ESPECIFICAS de uma campanha,',
  'para ser importado na plataforma Abrace uma Causa (tela FAQ da campanha > Importar JSON).',
  '',
  '---',
  '',
  '## Passo 1 - Descobrir as categorias e subcategorias validas',
  '',
  'As categorias e subcategorias usadas no JSON PRECISAM existir na Base de Conhecimento.',
  'Liste as disponiveis com uma chamada GET (sem autenticacao):',
  '',
  '```',
  'GET https://api.homologacao.abraceumacausa.com.br/api/Faq/ListCategories',
  '```',
  '',
  '> Em producao, troque o host pelo da producao.',
  '',
  'A resposta traz todas as categorias ativas com suas subcategorias aninhadas. Use os',
  'valores do campo "name" EXATAMENTE como vierem (o nome e a chave de ligacao).',
  '',
  'Exemplo de resposta (campo data):',
  '',
  '```json',
  '[',
  '  {',
  '    "id": 1,',
  '    "name": "Acesso e Cadastro",',
  '    "subcategories": [',
  '      { "id": 1, "name": "Alteracao de Dados" },',
  '      { "id": 2, "name": "Cadastro Obrigatorio" }',
  '    ]',
  '  },',
  '  {',
  '    "id": 3,',
  '    "name": "Institucional",',
  '    "subcategories": [',
  '      { "id": 20, "name": "Sobre a Campanha" }',
  '    ]',
  '  }',
  ']',
  '```',
  '',
  'Se a categoria/subcategoria que voce precisa NAO existir nessa lista, ela deve ser criada',
  'antes na tela Base de Conhecimento (o import nao cria categorias/subcategorias).',
  '',
  '---',
  '',
  '## Passo 2 - Montar o JSON',
  '',
  'Agrupe as perguntas por categoria e subcategoria (pelos nomes do Passo 1):',
  '',
  '```json',
  '{',
  '  "categorias": [',
  '    {',
  '      "nome": "Institucional",',
  '      "subcategorias": [',
  '        {',
  '          "nome": "Sobre a Campanha",',
  '          "perguntas": [',
  '            {',
  '              "pergunta": "O que e esta campanha?",',
  '              "resposta": "<p>A campanha arrecada recursos para <b>projetos sociais</b>.</p>",',
  '              "visivelAoDoador": true',
  '            }',
  '          ]',
  '        }',
  '      ]',
  '    }',
  '  ]',
  '}',
  '```',
  '',
  '### Campos',
  '',
  '| Campo | Obrigatorio | Descricao |',
  '|---|---|---|',
  '| `categorias[].nome` | sim | Nome EXATO de uma categoria existente (Passo 1) |',
  '| `subcategorias[].nome` | sim | Nome EXATO de uma subcategoria existente dentro da categoria |',
  '| `perguntas[].pergunta` | sim | Texto da pergunta |',
  '| `perguntas[].resposta` | sim | Resposta em HTML |',
  '| `perguntas[].visivelAoDoador` | nao (padrao true) | true = aparece pro doador; false = somente IA |',
  '',
  '### HTML permitido na resposta',
  '',
  '- Paragrafos: <p>...</p>',
  '- Negrito/italico/sublinhado: <b>, <i>, <u>',
  '- Listas: <ul><li>...</li></ul> e <ol><li>...</li></ol>',
  '- Links: <a href="https://...">texto</a>',
  '',
  'Evite estilos inline pesados, scripts ou tabelas complexas.',
  '',
  '---',
  '',
  '## Cuidados',
  '',
  '- Gere apenas perguntas ESPECIFICAS da campanha. Nao repita perguntas que ja sao gerais',
  '  da plataforma (essas ficam na Base de Conhecimento e ja aparecem automaticamente).',
  '- Nao invente nomes de categoria/subcategoria: use somente os retornados no Passo 1.',
  '- Reimportar o mesmo JSON cria perguntas novas (nao ha deduplicacao por titulo).'
];

export const FAQ_IMPORT_INSTRUCTIONS = lines.join('\n');
